import Logger from './logger'

const DEFAULT_FAILSAFE_TIMEOUT = 3_000
const SECOND_MSEC = 1_000

/**
 * 複数の入札サービスに対してまとめて入札を行う。
 */
export default class BidderServiceManager implements BidderService {
    public name = 'manager'
    private readonly bidBackedStates: Dict<boolean>
    private readonly failsafeTimeout: number

    constructor(config: HeaderBiddingConfig, private readonly bidders: BidderService[]) {
        this.bidBackedStates = {}
        bidders.forEach(bidder => {
            this.bidBackedStates[bidder.name] = false
        })
        this.failsafeTimeout = config.failsafeTimeout || DEFAULT_FAILSAFE_TIMEOUT
    }

    public addSlot(...slots: SlotDefinition[]) {
        this.bidders.forEach(bidder => bidder.addSlot(...slots))
    }

    public requestBids(slots: SlotDefinition[], callback: Command) {
        if (this.bidders.length === 0) {
            callback()
            return
        }

        let isCalled = false

        this.bidders.forEach(bidder => {
            bidder.requestBids(slots, () => {
                this.bidBackedStates[bidder.name] = true
                if (this.isNotBidBacked()) return
                if (isCalled) return
                isCalled = true
                callback()
            })
        })

        // 入札が指定時間内に完了しなかったら広告を表示する
        setTimeout(() => {
            if (isCalled) return
            isCalled = true
            Logger.warn(
                `${this.failsafeTimeout /
                    SECOND_MSEC} 秒以内に入札が完了しなかったため広告を配信します`,
            )
            callback()
        }, this.failsafeTimeout)
    }

    public preRenderAds(slots: SlotDefinition[]) {
        this.bidders.forEach(bidder => bidder.preRenderAds(slots))
    }

    private isNotBidBacked() {
        return !this.isBidBackedAll()
    }

    private isBidBackedAll() {
        for (const name in this.bidBackedStates) {
            if (this.bidBackedStates[name] !== true) return false
        }
        return true
    }
}
